// extracted by mini-css-extract-plugin
export var locationCard = "_qx-0";